import { useContext, useEffect, useState } from "react"
import { Table } from "src/component"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, AppText, CustomContainer, FlexRow, GridContainer } from "src/style"
import { feesColumns, customerFeeData, serviceProviderFeeData } from "src/utils/table-layout"
import { ServiceFee } from "src/model"

export const ProductServiceAccordion: React.FC<any> = ({data, expandedRowId, isBillingSetup, product}) => {
    const {API} = useContext(ApiContext)
    const [serviceFee, setServiceFee] = useState<ServiceFee|null>(null)

    useEffect(() => {
        handleFetchServiceFee()
    }, [])

    async function handleFetchServiceFee () {
        const response = await API.getServiceFee(product.id, data?.id)

        if (response) setServiceFee(response)
    }

    return (
        <CustomContainer 
            bgColor="#F9FAFB"
            className={`expandable-content ${data?.id === expandedRowId ? 'expanded' : ''}`}
            padding='1.5'
        >
            <CustomContainer 
                bgColor="#ffffff" padding="1.5" radius="0.8"
                box-shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
            >
                <AppText 
                    textSize="2" color="#101828" 
                    fontWeight="500" bottomPadding="1.5"
                    style={{borderBottom: '1px solid #EAECF0'}}
                >
                    Fee configuration details
                </AppText>
                <CustomContainer topMargin="1.6">
                    <FlexRow gap="4">
                        <AppSpan color="#333542" textSize="1.6" fontWeight="600">
                            Fee Type
                        </AppSpan>
                        <FlexRow width="auto" sizeUnit="" gap="4">
                            { !isBillingSetup &&
                                <GridContainer
                                    width="auto" sizeUnit="" bottomPadding="0.2"
                                    minHeight="2.2" topPadding="0.2"
                                    radius="1.6" bgColor="#f2f4f7"
                                    leftPadding="0.8" rightPadding="0.8"
                                >
                                    <AppSpan color="#344054" fontWeight='500' textSize="1.2">{serviceFee?.feeType}</AppSpan>
                                </GridContainer>
                            }
                            {/* <GridContainer
                                width="auto" sizeUnit="" bottomPadding="0.2"
                                minHeight="2.2" topPadding="0.2"
                                radius="1.6" bgColor="#f2f4f7"
                                leftPadding="0.8" rightPadding="0.8"
                            >
                                <AppSpan color="#344054" fontWeight='500' textSize="1.2">Flat fee</AppSpan>
                            </GridContainer> */}
                        </FlexRow>
                    </FlexRow>
                    <Table 
                        tableData={serviceFee?.feeList}
                        tableColumns={feesColumns()} 
                        shouldPaginate={false}
                        customStyle
                    />
                </CustomContainer>
            </CustomContainer>
        </CustomContainer>
    )
}